import { render } from "./Chromosome.vue?vue&type=template&id=90845d12&scoped=true"
import script from "./Chromosome.vue?vue&type=script&lang=js"
export * from "./Chromosome.vue?vue&type=script&lang=js"

import "./Chromosome.vue?vue&type=style&index=0&id=90845d12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90845d12"]])

export default __exports__